import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";

import DocumentosUsuario from "./usuario/DocumentosUsuario";

export default function IntranetUsuarioDocumentosPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <DocumentosUsuario
      onVolver={() => navigate("/menu/intranet/usuario")}
      initialDoc={initialItem}
    />
  );
}
